<template>
    <div style="padding: 4px 8px;">
        <input
            type="datetime-local"
            class="form-control form-control-sm mb-2"
            style="width: auto;"
            v-model="pendingValue"
            @change="apply"
        />
        <div class="d-flex align-items-center" style="gap: 12px;">
            <button class="btn btn-link btn-sm" style="padding: 0;" @click="setRelativeDay(-1)">Yesterday</button>
            <button class="btn btn-link btn-sm" style="padding: 0;" @click="setNow">Today</button>
            <button class="btn btn-link btn-sm" style="padding: 0;" @click="setRelativeDay(1)">Tomorrow</button>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'Calendar',
    props: {
        currentTab: {
            type: String,
            default: '',
        },
    },
    emits: ['close'],
    data() {
        return {
            pendingValue: '',
        }
    },
    computed: {
        ...mapState(['date']),
    },
    methods: {
        ...mapMutations(['setDate']),
        apply() {
            if (!this.pendingValue) return
            this.setDate(new Date(this.pendingValue))
            this.$emit('close')
        },

        setNow() {
            const now = new Date()
            this.pendingValue = this.toInputValue(now)
            this.setDate(now)
            this.$emit('close')
        },
        setRelativeDay(offset) {
            const d = new Date(this.date || new Date())
            d.setDate(d.getDate() + offset)
            this.pendingValue = this.toInputValue(d)
            this.setDate(d)
            this.$emit('close')
        },
        toInputValue(date) {
            const pad = n => String(n).padStart(2, '0')
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
        },
    },
    mounted() {
        if (!this.date) {
            const now = new Date()
            this.pendingValue = this.toInputValue(now)
            this.setDate(now)
        } else {
            this.pendingValue = this.toInputValue(this.date)
        }
    },
}
</script>
